module.exports = __webpack_public_path__ + "assets/img/HeroopSys.6f42e995.png";